import React from "react";
import { POSTAPI, generateHeader } from "src/api-setup/api-helper";
import { transformDateTime } from "src/lib/date-time.util";
import { formatSystemDateTime, GridColumnDataMapper } from "src/utils/utils";

export default function AuditLogs() {
  const [columns, setColumns] = React.useState([]);
  const [noDataFound, setNoDataFound] = React.useState(false);
  const [isSearchClick, setSearchClick] = React.useState(false);
  const [initialLoading, setLoadingState] = React.useState(false);
  const [dataCount, setDataCount] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [isAPICalling, setAPICallingState] = React.useState(false);

  const getListDataAsync = (api, reqBody, dispatch) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, api, null, generateHeader(), reqBody, dispatch).then((res) => {
        if (res.status) {
          setLoadingState(true);
          setSearchClick(false);
          let columnData = [];
          if (columns?.length === 0) {
            columnData = GridColumnDataMapper(res?.data?.out_parameters?.out_columns_xml);
            columnData.forEach((cItem) => {
              cItem.show = true;
            });
            setColumns(JSON.parse(JSON.stringify(columnData)));
          }

          let resData = JSON.parse(JSON.stringify(res.data.row_result));
          resData = resData.map((val) => {
            val.last_attempt_login_date = formatSystemDateTime(val?.last_attempt_login_date);
            val.last_success_login_date = formatSystemDateTime(val?.last_success_login_date);
            return val;
          });
          setLoadingState(true);
          setAPICallingState(true);
          setNoDataFound(false);
          setAPICallingState(false);
          setData(resData);
          setDataCount(res.data.out_parameters.out_total_rows);
          resolve(true);
        } else {
          setNoDataFound(true);
          setAPICallingState(false);
        }
      });
    }).then((res) => {
      return res;
    });
  };

  const getExportDataAsync = (api, reqData, dispatch) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, api, null, generateHeader(), reqData, dispatch).then((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          setNoDataFound(true);
          resolve(false);
        } else {
          if (res.status) {
            if (
              res.data.out_parameters.out_ret_code === 0 ||
              res.data.out_parameters.out_ret_code === 2 ||
              res.data.out_parameters_out_ret_code === 3
            ) {
              let resData = JSON.parse(JSON.stringify(res.data.row_result));

              let columnData = GridColumnDataMapper(res.data.out_parameters.out_columns_xml);
              columnData.forEach((cItem) => {
                cItem.show = true;
              });

              resData = JSON.parse(JSON.stringify(res.data.row_result));

              let colValue = columnData.length > 0 ? columnData : columns;
              colValue.map((item) => {
                if (item.type === "date") {
                  resData.forEach((rItem) => {
                    if (rItem[item.field] !== null && rItem[item.field] !== "0000-00-00 00:00:00") {
                      rItem[item.field] = transformDateTime({
                        date: rItem[item.field],
                        format: "MM/DD/YYYY",
                        includeTime: true,
                      });
                    }
                    if (rItem[item.field] === "0000-00-00 00:00:00") {
                      rItem[item.field] = "";
                    }
                  });
                }
                if (item.type === "boolean") {
                  resData.forEach((rItem) => {
                    rItem[item.field] = rItem[item.field] ? "true" : "false";
                  });
                }
                return 0;
              });

              resData.forEach((xItem) => {
                if (xItem.custom_table_type) {
                  xItem.custom_table_type = xItem.custom_table_type === "S" ? "Standard" : "Hierarchical";
                }
              });
              resolve(resData);
            }
          }
        }
      });
    }).then((res) => {
      return res;
    });
  };

  return [
    {
      columns,
      setColumns,
      data,
      setData,
      dataCount,
      initialLoading,
      noDataFound,
      isAPICalling,
      setAPICallingState,
      isSearchClick,
      setSearchClick,
    },
    {
      getListDataAsync,
      getExportDataAsync,
    },
  ];
}
